import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconEyeClose from "../../../assets/images/icon-eye-close.svg";
import IconEyeOpen from "../../../assets/images/icon-eye-open.svg";


const Container = styled.div`
    width: 100%;
    margin-bottom: 16px;
    position: relative;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .label-error {
        height: 16px;
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }

    .icon-password {
        width: 30px;
        position: absolute;
        right: 16px;
        top: 12px;
        cursor: pointer;

        &.with-label {
            top: 51px;
        }
    }
`;

const InputBox = styled.input`
    width: calc(100% - 72px);
    height: 50px;
    border-radius: 13px;
    border: 1px solid #FBE250;
    color: #25368D;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 56px 0px 16px;

    &.error {
        border: 1px solid #F84242 !important;
    }

    &:disabled {
        cursor: default;
        background-color: #B3B3B333;
    }
`;

function InputComponent({
    label,
    value,
    type,
    placeholder,
    labelError,
    isError,
    disable,
    max,
    min,
    styleContainer,
    classContainer,
    styleInput,
    classInput,
    onInput,
    onEnter,
    onPaste,
    onBlur,
}) {
    const [inputValue, setInputValue] = useState("");
    const [inputType, setInputType] = useState("text")

    useEffect(() => {
        setInputValue(value || "");
    }, [value])

    useEffect(() => {
        if (type) {
            setInputType(type)
        }
        // if (type === "password") {
        //     setInputType(type)
        // }
    }, [type])

    function handleInput(param) {
        if (disable) return;
        let value = param.target.value;
        setInputValue(value)
        onInput && onInput(value)
    }
    function handleToggleShowPassword() {
        if (inputType === "password") {
            setInputType("text")
        } else if (inputType === "text") {
            setInputType("password")
        }
    }
    function handleKeyPress(event) {
        if (event.key === 'Enter') {
            onEnter && onEnter(event)
        }
    };
    function handlePaste(param) {
        if (disable) return;
        let value = param.target.value;
        setInputValue(value)
        onPaste && onPaste(param, value)
    };
    function handleBlur() {
        if (disable) return;
        onBlur && onBlur()
    };

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label && <div className="label">{label}</div>}
            <InputBox
                className={`${classInput} ${isError ? "error" : ""}`}
                style={{ ...styleInput, }}
                placeholder={placeholder || ""}
                value={inputValue}
                disabled={disable}
                type={inputType}
                max={max}
                min={min}
                onInput={(e) => { handleInput(e) }}
                onKeyPress={handleKeyPress}
                onPaste={(e) => { handlePaste(e) }}
                onBlur={handleBlur}
            />
            {type === "password" &&
                <img
                    alt="img"
                    className={`icon-password ${label ? "with-label" : ""}`}
                    src={inputType === "password" ? IconEyeClose : IconEyeOpen}
                    onClick={handleToggleShowPassword}
                />
            }
            <div className="label-error">{isError ? labelError : ""}</div>
        </Container>
    )
}

export default InputComponent;